function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.92913 19.0715C1.02361 15.166 1.02361 8.83403 4.9292 4.92845C8.8347 1.02385 15.1665 1.02385 19.072 4.92845C22.9776 8.83403 22.9776 15.166 19.072 19.0716C15.1665 22.9762 8.8347 22.9762 4.92913 19.0715ZM17.8936 17.893C21.1482 14.6383 21.1482 9.36168 17.8936 6.10705L17.7141 5.93286C14.4478 2.85431 9.30307 2.91239 6.10767 6.10705C2.85304 9.36168 2.85304 14.6383 6.1076 17.8929C9.36225 21.1468 14.639 21.1468 17.8936 17.893ZM12.0008 7.83342C12.4282 7.83342 12.7804 8.15512 12.8285 8.56958L12.8341 8.66677V11.1668H15.3342C15.7944 11.1668 16.1675 11.5399 16.1675 12.0002C16.1675 12.4275 15.8458 12.7798 15.4314 12.8279L15.3342 12.8335H12.8341V15.3336C12.8341 15.7938 12.461 16.1669 12.0008 16.1669C11.5734 16.1669 11.2212 15.8452 11.173 15.4308L11.1674 15.3336V12.8335H8.66738C8.20714 12.8335 7.83403 12.4604 7.83403 12.0002C7.83403 11.5728 8.15574 11.2206 8.5702 11.1724L8.66738 11.1668H11.1674V8.66677C11.1674 8.20652 11.5405 7.83342 12.0008 7.83342Z",
  fill: "#67EDFF"
});

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "assets/media/add.1055d4c9.svg";
export { ForwardRef as ReactComponent };